import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Dialog from 'react-toolbox/lib/dialog'
import CSSModules from 'helpers/CSSModulesUtil'
import { compose, withProps, branch, renderComponent, renderNothing } from 'recompose'
import * as R from 'ramda'
import P from 'helpers/predicates'
import T from 'i18n-react'
import { GREENLIGHT_STATES } from './constants'

import styles from './styles.scss'

class DialogComponent extends Component {
  onCancel = () => this.props.onDialogCancel()
  onSubmit = () => this.props.onDialogSubmit()

  actions = [
    { label: 'Cancel', onClick: this.onCancel },
    { label: 'Submit', onClick: this.onSubmit }
  ]

  render() {
    const {
      active,
      body,
      title,
      onDialogCancel
    } = this.props

    return (
      <Dialog
        active={active}
        actions={this.actions}
        title={title}
        onOverlayClick={onDialogCancel}
        onEscKeyDown={onDialogCancel}
        theme={styles}
      >
        <p>
          { body }
        </p>
      </Dialog>
    )
  }
}

const withType = withProps(
  ({ actionType }) => R.cond([
    [
      R.equals(GREENLIGHT_STATES.APPROVED),
      R.always({
        body: T.translate('containers.project.greenlightReport.dialog.approvedBody'),
        title: T.translate('containers.project.greenlightReport.dialog.approvedTitle'),
      })
    ],
    [
      R.equals(GREENLIGHT_STATES.REJECTED),
      R.always({
        body: T.translate('containers.project.greenlightReport.dialog.rejectedBody'),
        title: T.translate('containers.project.greenlightReport.dialog.rejectedTitle'),
      })
    ],
    [
      R.T,
      R.always({
        body: T.translate('containers.project.greenlightReport.dialog.pendingBody'),
        title: T.translate('containers.project.greenlightReport.dialog.pendingTitle'),
      })
    ]
  ])(actionType)
)

DialogComponent.propTypes = {
  active: PropTypes.bool.isRequired,
  onDialogCancel: PropTypes.func.isRequired,
  onDialogSubmit: PropTypes.func.isRequired,
}

const withStyle = CSSModules(styles)
export default compose(
  withType,
  withStyle
)(DialogComponent)
